export default __webpack_public_path__ + "static/22-5ca259b7fbf8d3248ac3396281dec370.jpg";